module.exports = __webpack_public_path__ + "static/img/Luc-Rémont_2017-18.e1baa6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Luc-Rémont_2017-18.jpg
// module id = wp4k
// module chunks = 0